var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"text-nowrap"},[_c('b-icon-dot',{staticClass:"mr-2",class:_vm.css,attrs:{"scale":"3.3"}}),_vm._v(" "+_vm._s(_vm.description))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }